const getLogString = (message: any, userAgent: string, escapeText: boolean) => {
  const retVal = `${message}:::${JSON.stringify(message)}:::${userAgent}:::${window.location.href}`;
  if (escapeText) {
    return escape(retVal);
  } else {
    return retVal;
  }
};
const noiseFilter = [
  //Let's skip AbortError and Request aborted from the logs as it's expected due to navigation makes cancelation of fetch
  /AbortError/i,
  /Request aborted/i,
  // Skip React hydration errors – almost always caused by browser extensions (ad blockers, translators, password managers, etc.)
  // modifying the DOM before React hydrates. These are not actionable bugs.
  /Hydration failed/i,
  /There was an error while hydrating/i,
  /Minified React error #(418|423|425|422)/i,
];

const log = (message: any) => {
  if (!message) {
    return;
  }
  const rawLogString = getLogString(message, navigator.userAgent, false);
  if (noiseFilter.some((noise) => rawLogString?.match(noise))) {
    return;
  }
  const logString = getLogString(message, navigator.userAgent, true);

  const url = "/c/api/frontendlogger/";

  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "message=" + logString,
  })
    .then((res) => res.json())
    .then((res) => {
      // eslint-disable-next-line no-console
      console.log("Error logged to server: " + res + getLogString(message, navigator.userAgent, false));
    });
};

const windowOnErrorHandler = function (msg: any, url: any, line: any, col: any, error: any) {
  const isEmptyError = function (msg: any, url: any) {
    return (msg === undefined || msg === "Script error.") && (url === undefined || url === "");
  };

  const logError = function (msg: any, url: any, line: any, col: any, stacktrace: any) {
    if (isEmptyError(msg, url)) {
      return true;
    }

    let text = "[Error]: " + msg;
    text += " [URL]: " + url;
    text += " [Line]: " + line;

    if (col) {
      text += " [Col]: " + col;
    }

    if (stacktrace) {
      text += " [Stack]: " + JSON.stringify(stacktrace);
    }

    log(text);
  };

  logError(msg, url, line, col, error);

  return true;
};

export const attachLoggerToOnErrorEvent = () => {
  window.addEventListener("error", (event) => {
    const { error, lineno, colno, message } = event;
    const allMessages = `message=${message} error.message=${error?.message}`;
    windowOnErrorHandler(allMessages, window?.location?.href, lineno?.toString(), colno?.toString(), error?.stack);
  });
};

export default {
  logError: log,
  getLogString,
  windowOnErrorHandler,
  attachLoggerToOnErrorEvent,
};
